// extracted by mini-css-extract-plugin
export default {"page":"page_page__m+sfe"};